import {NotificationGroupEvent} from './notification-group-event.model';
import {NotificationGroupPermissionGroup} from './notification-group-permission-group.model';
import {MyNotificationGroupOverride} from './my-notification-group-override.model';

export class NotificationGroup {

    // Server Properties
    ID: number;
    Name: string;
    Description: string;
    AllowOverride: boolean;
    Status: string;
    AddedOn: Date;
    AddedBy: number;
    LastUpdatedOn: Date;
    LastUpdatedBy: number;
    NotificationGroupEvents: NotificationGroupEvent[] = [];
    NotificationPermissionGroups: NotificationGroupPermissionGroup[] = [];
    MyNotificationGroupOverrides: MyNotificationGroupOverride[] = [];

    // Local Properties
    eventsDisplay: string;
    permissionGroupsDisplay: string;

    // Constructor
    constructor() {
        this.ID = -1;
        this.Status = 'Active';
    }

    // Functions
    hasTypeOfEvent(eventID: number, typeID: number) {
        return !!this.NotificationGroupEvents.find(notificationGroupEvent =>
            notificationGroupEvent.NotificationEvent_ID == eventID && notificationGroupEvent.NotificationType_ID == typeID
        );
    }
}
